
  const swiper = new Swiper('.swiper', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  mousewheel: {
    forceToAxis: true,
  },
  onload: function () {
    if (swiper.slides.length <= 1) {
      swiper.navigation.destroy();
      swiper.scrollbar.destroy();
    }
    swiper.update();
  }

});
document.addEventListener('DOMContentLoaded', function () {
  swiper.update();
});